module.exports = __webpack_public_path__ + "705b1348460b1291d9373798b0d2993e.svg";